import {
    GET_SCHEDULED_TASKS_REQUEST,
    GET_SCHEDULED_TASKS_SUCCESS,
    GET_SCHEDULED_TASKS_FAILURE
} from '../actions';


const initialState = {};

const ScheduledTasksReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SCHEDULED_TASKS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_SCHEDULED_TASKS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_SCHEDULED_TASKS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default ScheduledTasksReducer;